import "./Table.css";

const Table = ({
  columns = [],
  data = [],
  loading = false,
  emptyText = "No data found",
  className = "",
  clickable,
}) => {
  // Rows are only focusable/clickable when the caller handles row clicks.
  const rowProps = (row) =>
    clickable
      ? {
          className: "ui-table-row-clickable",
          tabIndex: 0,
          onClick: () => clickable(row),
          onKeyDown: (e) => {
            if (e.target !== e.currentTarget) return;
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              clickable(row);
            }
          },
        }
      : {};

  return (
    <div className={`ui-table-wrapper ${className}`}>
      <table className="ui-table" aria-busy={loading || undefined}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className={col.mobile === false ? "col-mobile-hide" : ""}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} className="ui-table-state">
                Loading...
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="ui-table-state">
                {emptyText}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={row.id || row._id || rowIndex} {...rowProps(row)}>
                {columns.map((col) => (
                  <td
                    key={col.key}
                    data-label={col.label}
                    className={col.mobile === false ? "col-mobile-hide" : ""}
                  >
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;